export const FS_ID = "XATAV0HZ0MUVRNP2DMR4202KKJVBPO4PPHI21YNDSNKBSXUC";
export const FS_SECRET = "HTTEZQMQKMOGQXK1PWLOC3UTZI3HTWLULBMGZG5RY5T4UH1X";
export const G_KEY = "AIzaSyB_al7nqZ8PmQFuFB9WqcQPNKQQI_m6fs4";